// extracted by mini-css-extract-plugin
module.exports = {"Admin":"_3StnCPt4","block":"_2vjFGr-F","statusHeader":"_1Gm-Il8J","nameHeader":"JCeRnwzg","header":"_2oe_gMAF","top":"FsGL1yH_","left":"_3be8dRVu","text":"_3RM9xPLb"};
    if(module.hot) {
      // 1754515035678
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  